import { createRouter, createWebHistory } from 'vue-router'

import Layout from '@/layout'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue'),
  },
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: '全局概览',
        component: () => import('../views/home/index.vue'),
      },
      {
        path: '/core',
        name: '核心指标',
        component: () => import('../views/home/core.vue'),
      },
      {
        path: '/equipment/list',
        name: '设备列表',
        component: () => import('../views/equipment/list.vue'),
      },
      {
        path: '/equipment/state',
        name: '状态统计',
        component: () => import('../views/equipment/state.vue'),
      },
      {
        path: '/examAnalysis/areaStatistics',
        name: '地区统计',
        component: () => import('../views/examAnalysis/areaStatistics.vue'),
      },
      {
        path: '/examAnalysis/jobSubject',
        name: '作业科目分析',
        component: () => import('../views/examAnalysis/jobSubject.vue'),
      },
      {
        path: '/examAnalysis/examPlan',
        name: '考试计划详情',
        component: () => import('../views/examAnalysis/examPlan.vue'),
      },
      {
        path: '/examAnalysis/passRate',
        name: '通过率',
        component: () => import('../views/examAnalysis/passRate.vue'),
      },
      {
        path: '/examSiteAnalysis/examSiteInfo',
        name: '考点统览',
        component: () => import('../views/examSiteAnalysis/examSiteInfo.vue'),
      },
      {
        path: '/examSiteDetail',
        name: '考点详情-概览',
        component: () => import('../views/examSiteDetail/index.vue'),
      },
      {
        path: '/examSiteAnalysis/examSiteCompared',
        name: '考点对比',
        component: () => import('../views/examSiteAnalysis/examSiteCompared.vue'),
      },
      {
        path: '/trainAnalysis/traineeList',
        name: '学员概览',
        component: () => import('../views/trainAnalysis/traineeList.vue'),
      },
      {
        path: '/trainAnalysis/onlineLearn',
        name: '在线学习',
        component: () => import('../views/trainAnalysis/onlineLearn.vue'),
      },
      {
        path: '/trainAnalysis/typeSubjectCount',
        name: '工种科目统计',
        component: () => import('../views/trainAnalysis/typeSubjectCount.vue'),
      },
      {
        path: '/trainAnalysis/trainAgencyList',
        name: '培训机构列表',
        component: () => import('../views/trainAnalysis/trainAgencyList.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
